import React, { useContext } from 'react';
import PrimaryDesktopActionBar from './PrimaryDesktopActionBar';
import SecondaryDesktopActionBar from './SecondaryDesktopActionBar';
import { ActionBarContext } from '../../ActionBarContext';
export const DesktopActionBar = (props)=>{
    const actionBarType = useContext(ActionBarContext);
    return actionBarType === 'secondary' ? /*#__PURE__*/ React.createElement(SecondaryDesktopActionBar, props) : /*#__PURE__*/ React.createElement(PrimaryDesktopActionBar, props);
};
DesktopActionBar.displayName = 'DesktopActionBar';
export default DesktopActionBar;

//# sourceMappingURL=DesktopActionBar.js.map